import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";


export interface ToastMessage {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private toastSubject = new BehaviorSubject<ToastMessage | null>(null);
  toast$ = this.toastSubject.asObservable();

  showToast(type: 'success' | 'error' | 'warning' | 'info', message: string) {
    this.toastSubject.next({type, message});
    setTimeout(() => this.clearToast(), 5000);
  }

  clearToast() {
    this.toastSubject.next(null);
  }
  constructor() { }
}
